// Mappa colori cavi
export const COLOR_MAP = {
    'ARANCIO': '#FF6B35', 'ORANGE': '#FF6B35',
    'BIANCO': '#FFFFFF', 'WHITE': '#FFFFFF',
    'BLU': '#2196F3', 'BLUE': '#2196F3',
    'GIALLO': '#FFD600', 'YELLOW': '#FFD600',
    'GI/VE': null, 'YE/GN': null,
    'GRIGIO': '#808080', 'GRAY': '#808080',
    'ROSSO': '#F44336', 'RED': '#F44336',
    'MARRONE': '#8B4513', 'BROWN': '#8B4513',
    'NERO': '#000000', 'BLACK': '#000000',
    'VERDE': '#4CAF50', 'GREEN': '#4CAF50',
    'VIOLA': '#9C27B0', 'PURPLE': '#9C27B0'
};

// Colori disponibili per lingua
export const COLORI_MAPPINGS = {
    it: ['ARANCIO', 'BIANCO', 'BLU', 'GIALLO', 'GI/VE', 'GRIGIO', 'ROSSO', 'MARRONE', 'NERO', 'VERDE', 'VIOLA'],
    en: ['ORANGE', 'WHITE', 'BLUE', 'YELLOW', 'YE/GN', 'GRAY', 'RED', 'BROWN', 'BLACK', 'GREEN', 'PURPLE']
};

// Mappatura traduzione colori
export const COLOR_TRANSLATION = {
    'ARANCIO': 'ORANGE', 'ORANGE': 'ARANCIO',
    'BIANCO': 'WHITE', 'WHITE': 'BIANCO',
    'BLU': 'BLUE', 'BLUE': 'BLU',
    'GIALLO': 'YELLOW', 'YELLOW': 'GIALLO',
    'GI/VE': 'YE/GN', 'YE/GN': 'GI/VE',
    'GRIGIO': 'GRAY', 'GRAY': 'GRIGIO',
    'ROSSO': 'RED', 'RED': 'ROSSO',
    'MARRONE': 'BROWN', 'BROWN': 'MARRONE',
    'NERO': 'BLACK', 'BLACK': 'NERO',
    'VERDE': 'GREEN', 'GREEN': 'VERDE',
    'VIOLA': 'PURPLE', 'PURPLE': 'VIOLA'
};

// Costanti per i colori dei terminali
export const TERMINAL_COLORS = {
  PSW: '#FFFFFF', PSR: '#FF0000', PSN: '#000000',
  PSB: '#2196F3', PSG: '#BFBFBF', PSY: '#FFFF00', PSR10: '#FF0000', PSB10: '#2196F3',
  PDW: '#FFFFFF', PDR: '#FF0000', PDN: '#000000',
  PDB: '#2196F3', PDG: '#BFBFBF', PDY: '#FFFF00', PDR10: '#FF0000',
  FRx: '#FF0000', FBx: '#2196F3', FYx: '#FFFF00',
  ORx: '#FF0000', OBx: '#2196F3', OYx: '#FFFF00',
  MLM: '#CECECE', MLF: '#CECECE',
  TR: '#FF0000', TB: '#2196F3', TY: '#FFFF00',
  'FSR2.8': '#FF0000', 'FSR4.8': '#FF0000', 'FSR6.3': '#FF0000',  
  'FCR4.8': '#FF0000', 'FCR6.3': '#FF0000', 'FCB4.8': '#2196F3', 'FCB6.3': '#2196F3', FAS: '#FF0000'
};